
var resizableLess = {};
var moveableLess = {};
var hidableLess = {};
import genaration from '../../utils/classname';
export var hidableClass = genaration(hidableLess, 'hidable');
export var moveableClass = genaration(moveableLess, 'moveable');
export var resizableClass = genaration(resizableLess, 'resizable');